module.exports = __webpack_public_path__ + "img/wyy.d57be596.png";